// extracted by mini-css-extract-plugin
var _1 = "ProfileImage_camera__X0NVo";
var _2 = "ProfileImage_imageContainer__6nE8h";
var _3 = "992px";
var _4 = "768px";
var _5 = "ProfileImage_profileImage__8gxaX";
var _6 = "\"../shared.module.css\"";
export { _1 as "camera", _2 as "imageContainer", _3 as "lg", _4 as "md", _5 as "profileImage", _6 as "shared" }
